module.exports = __webpack_public_path__ + "img/italy.d8ce3424.svg";